import React from 'react';
import { getTxExplorerUrl } from '../utils/transactions';

const PHASE_STYLES = {
  signing: {
    bg: 'bg-blue-50 border-blue-200 text-blue-800',
    dot: 'bg-blue-500 animate-pulse',
  },
  pending: {
    bg: 'bg-blue-50 border-blue-200 text-blue-800',
    dot: 'bg-blue-500 animate-pulse',
  },
  success: {
    bg: 'bg-green-50 border-green-200 text-green-800',
    dot: 'bg-green-500',
  },
  error: {
    bg: 'bg-red-50 border-red-200 text-red-800',
    dot: 'bg-red-500',
  },
};

const TxBanner = ({ txState }) => {
  if (!txState || txState.phase === 'idle') return null;

  const style = PHASE_STYLES[txState.phase] || PHASE_STYLES.signing;
  const explorerUrl = getTxExplorerUrl(txState.txHash);

  return (
    <div className={`rounded-lg border p-4 mb-4 ${style.bg}`}>
      <div className="flex items-start gap-3">
        <span className={`mt-1.5 h-2.5 w-2.5 rounded-full flex-shrink-0 ${style.dot}`} />
        <div className="min-w-0 flex-1">
          {txState.action && (
            <div className="text-xs font-semibold uppercase tracking-wide opacity-70 mb-0.5">
              {txState.action}
            </div>
          )}
          <p className="text-sm font-medium">{txState.message}</p>
          {explorerUrl && txState.phase !== 'signing' && (
            <a
              href={explorerUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs underline mt-1 inline-block opacity-80 hover:opacity-100"
            >
              View transaction on BaseScan ↗
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default TxBanner;
